import lazyLoading from '../utils'
import { routes as dashboard } from './dashboard'
import { routes as user } from './user'
import { routes as auth } from './auth'
import { routes as minskDocuments } from './minsk'
import { routes as regionDocuments } from './regions'
import { routes as shipmentDocuments } from './shipment'
import multiGuard from 'vue-router-multiguard'
import authGuard from './authGuard'
import userGuard from './userGuard'

export default [
  {
    path: '/',
    component: lazyLoading('tradle/components/Tradle'),
    beforeEnter: multiGuard([authGuard, userGuard]),
    children: [
      ...dashboard,
      ...user,
      ...minskDocuments,
      ...regionDocuments,
      ...shipmentDocuments
    ]
  },
  {
    path: '/auth',
    component: lazyLoading('auth/components/Layout'),
    children: [
      ...auth
    ]
  }
]
